import brand from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import DotPaginationStyles from '@stories/Components/DotPagination/DotPagination.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --fgColor: ${brand.white};

  position: relative;
  display: grid;
  color: var(--fgColor);
  min-height: 92vh;
  overflow: hidden;
  overflow: clip;
`;
const ItemList = styled.div `
  display: grid;
  grid-area: 1 / 1;
`;
const PaginationWrapper = styled.div `
  @media ${until(Device.DesktopSmall)} {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    padding-bottom: 32px;
    place-content: center;
    place-items: center;
    width: 100%;
    z-index: 3;
  }

  @media ${from(Device.DesktopSmall)} {
    ${siteWide};

    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row;
    grid-area: 1 / 1;
    justify-content: flex-start;
    padding-top: var(--headerHeight);
    pointer-events: none;
    z-index: 3;

    ${DotPaginationStyles.Container} {
      --direction: column;
      pointer-events: all;
    }
  }
`;
const HomeHeroBannerStyles = {
    Container,
    ItemList,
    PaginationWrapper,
};
export default HomeHeroBannerStyles;
